module.exports = __webpack_public_path__ + "static/img/360aq_img_2.08471341.png";